// Angular Files
import { Component, inject } from '@angular/core';

// Teller Online Library Files
import { TellerOnlineSiteMetadataService } from 'teller-online-libraries/core';
import { MenuItemDto } from 'libraries/core/src/lib/api/CoreWebApi';
import { MatSidenav } from '@angular/material/sidenav';

@Component({
    selector: 'app-mobile-menu',
    templateUrl: 'mobile-menu.component.html',
    styleUrls: ['./mobile-menu.component.scss'],
    host: {
        class: 'mobile-menu'
    },
    standalone: false
})
export class MobileMenuComponent {
    private sidenav = inject(MatSidenav);

    constructor(public siteMetadataService: TellerOnlineSiteMetadataService) { }

    public get menuItems(): MenuItemDto[] {
        return this.siteMetadataService.menuItems ?? [];
    }

    public close() {
        this.sidenav.close();
    }
}
